





































































import Vue from 'vue';

import { VBTooltip, BRow, BCol } from 'bootstrap-vue';
import { mapActions, mapGetters } from 'vuex';

import { ZenFormGroup } from 'zenComponents';
import { pluralize } from '@/utils/vue_filters';
import { getTooltipOptions } from '@/components/tooltips/utils';

import { Audit } from '../types';

export default Vue.extend({
  name: 'ASWStep5',
  components: {
    BCol,
    BRow,
    ZenFormGroup,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  filters: {
    pluralize,
  },
  props: {
    audit: {
      type: Object as () => Audit,
      required: true,
    },
  },
  computed: {
    ...mapGetters('auditSetupWizard', ['getNumberOfRequests']),
  },
  async created() {
    if (!this.isManagedInZenGRC) {
      await this.loadRemoteRequests();
    }
  },
  methods: {
    ...mapActions('auditSetupWizard', ['loadRemoteRequests', 'isManagedInZenGRC']),
    getTooltipOptions,
  },
});
